import cx from 'classnames';

import { CDN_CLRSAVE_URL } from '../../constants';
import { HOME_PAGE_FEATURED } from '../../constants/homePageStatic';

import styles from '../../styles/homePage/featured.scss';
import { handleTrack } from '../../utils/trackActions';

interface Article {
  title: string;
  link: string;
}

const Featured = () => (
  <div className={'row'}>
    <div
      className={cx(styles.wrapper, 'large-10', 'columns', 'large-offset-1')}
    >
      <h5 className={cx(styles.title, 'mb20')}>{HOME_PAGE_FEATURED.title}</h5>
      <div className={cx(styles.featured, 'row')}>
        {(HOME_PAGE_FEATURED.articles || []).map((article: Article) => (
          <a
            onClick={e =>
              handleTrack({
                label: 'featured_articles_textLink',
                url: article.link,
                obj: e.target,
              })
            }
            className={cx(styles.article, 'columns', 'large-6')}
            key={article.title}
            href={article.link}
            target="_blank"
          >
            <img
              src={`${CDN_CLRSAVE_URL}/clearsave/images/book.svg`}
              alt={article.title}
              className={styles.image}
            />
            <div className={styles['article-title']}>{article.title}</div>
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default Featured;



// WEBPACK FOOTER //
// ./components/homePage/featured.tsx